import React from 'react';
import eye_icon from "../../assets/eye_icon.svg";
import edit_icon from "../../assets/edit_icon.svg";
import { Tooltip as WmsTooltip } from "react-tooltip";
import history from "../../assets/icons/timer1.svg";
import { deleteIcon } from '../../constant';
import PropTypes from 'prop-types';

const ActionItems = (props) => {
    const { type, item, handleAction, iconType, iconContent, icon = '' } = props;

    const showIcon = () => {
        let src;
        if (type === 'View') {
            src = eye_icon;
        } else if (type === 'Edit') {
            src = edit_icon;
        } else if (type === 'History') {
            src = history;
        } else if (type === 'Delete') {
            src = deleteIcon;
        } else {
            src = '';
        }
        return src
    }

    return (
        <>
            {type === 'icon' ? (
                <>
                    <button className="iconBtnListing mr-15 cursorPointer" id={`${item.id}${type}${icon}`} onClick={handleAction}>
                        <i className={iconType} aria-hidden="true"></i>
                    </button>
                    <WmsTooltip
                        anchorId={`${item.id}${type}${icon}`}
                        content={iconContent}
                        place="right"
                        className="tooltipWidth"
                    />
                </>
            ) : (
                <>
                    <button
                        type="button"
                        className="editIcon-btn mr-15 sortBtn"
                        onClick={handleAction}
                        id={`${item.id}+${type}`}
                        data-testid="editIcon"
                        aria-label="Edit"
                    >
                        <img src={showIcon()} alt="" className="editIcon" />
                    </button>
                    <WmsTooltip
                        anchorId={`${item.id}+${type}`}
                        content={type}
                        place="right"
                        className="tooltipWidth"
                    />
                </>
            )}

        </>
    );
};

ActionItems.propTypes = {
    type: PropTypes.string.isRequired,
    item: PropTypes.object.isRequired,
    handleAction: PropTypes.func.isRequired,
    iconType: PropTypes.string,
    iconContent: PropTypes.string,
    icon: PropTypes.string
};


export default ActionItems;